// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"a00a6622","172":"587cd380","214":"36137a6b","219":"6f394cad","465":"627a3df5","496":"c438268a","550":"757ed050","628":"806b2b11","634":"a02da292","655":"811d171e","706":"57f4df0a","860":"de566631","905":"b8edcaac","929":"336240c6"}[chunkId] + ".chunk.js";
};